export function getPreviousKey(obj:{}|null|undefined, key:string) : string | null {
  if (!obj)
    return null;
  const keys = Object.keys(obj);
  const index = keys.indexOf(key);
  if (index === -1 || index === 0) {
    return null; // No previous key
  }
  return keys[index - 1];
}


export function getNextKey(obj:{}|null|undefined, key:string) : string | null {
  if (!obj)
    return null;
  const keys = Object.keys(obj);
  const index = keys.indexOf(key);
  if (index === -1 || index === keys.length - 1) {
    return null; // No next key
  }
  return keys[index + 1];
}

export function getFirstKey(obj:{}|null|undefined) : string | null {
  if (!obj)
    return null;
  const keys = Object.keys(obj);
  if (keys.length === 0) {
    return null; // No keys
  }
  return keys[0];
}

export function getLastKey(obj:{}|null|undefined) : string | null {
  if (!obj)
    return null;
  const keys = Object.keys(obj);
  if (keys.length === 0) {
    return null; // No keys
  }
  return keys[keys.length - 1];
}
